module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_sns_01-e5b4a1aa6fabe99c30f3d05f5e1a1e9c.jpg";